import './custom-radio.scss';

export const CustomRadio = ({ id, checked, onChange, name }) => {
  return (
    <label className='radio__label'>
      <input 
        className='radio__input' 
        type="radio" 
        id={`radio-${id}`}
        checked={checked} 
        onChange={onChange} 
      />
      <span className='radio__custom'></span>
      <h6>{name}</h6>
    </label>
  );
};